import { Tab } from '@headlessui/react'
import { useSelectedCreditTabStore } from 'store'

import CustomHeadlessTabs from 'components/CustomHeadlessTabs'
import FallbackError from 'components/FallbackError'
import LoansTab from './LoansTab'
import AdvancesTab from './AdvancesTab'

const CreditTabs = () => {
  const { selectedTab, updateSelectedTab } = useSelectedCreditTabStore()

  return (
    <Tab.Group
      defaultIndex={selectedTab}
      onChange={(index) => updateSelectedTab(index)}
    >
      <CustomHeadlessTabs tabs={['Adelantos', 'Préstamos']} />
      <Tab.Panels className='w-full mb-16 transition-all duration-200'>
        <AdvancesTab />
        <LoansTab />
      </Tab.Panels>
    </Tab.Group>
  )
}

export default CreditTabs
